import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { ThreeSectionsLayout2, ThreeSectionsLayout2Component } from 'app/views/presentations/layouts/layouts/threeSectionsLayout2/threeSectionsLayout2.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(ThreeSectionsLayout2)
    ],
    declarations: [
        ThreeSectionsLayout2Component
    ],
    entryComponents: [
        ThreeSectionsLayout2Component
    ]
})
export class ThreeSectionsLayout2Module { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout2/threeSectionsLayout2.module.ts